/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */

export enum messageTypeEnum {
  ERROR = 'Error',
  CONFIGURATION_ERROR = 'ConfigurationError',
  INFORMATION = 'Information',
}
